import { IHoliday } from '@signal/asp-data-commons';
import produce from 'immer';
import * as fromActions from './holiday.actions';


export interface HolidayState {
  holidays: IHoliday[]
  loading: boolean,
  loaded: boolean,
  error: string,
  activeYear:string,
  department:string,
}

const initialState: HolidayState = {
  holidays: [],
  loading: false,
  loaded: false,
  error: '',
  activeYear:null,
  department:'',
};


export function holidayReducer(
  state: HolidayState = initialState,
  action: fromActions.HolidayActions): HolidayState {

  switch (action.type) {
    case fromActions.HolidayActionTypes.LOAD_HOLIDAYS: {
      return produce(state, draftState => {
        draftState.holidays = [];
        draftState.loaded = false;
        draftState.loading = true;
        draftState.activeYear = action instanceof fromActions.LoadHolidays ? action.payload.activeYear : '';
        draftState.department = action instanceof fromActions.LoadHolidays ? action.payload.department : '';
        draftState.error = '';
      });
    }
    case fromActions.HolidayActionTypes.LOAD_HOLIDAYS_BY_YEAR: {
      return produce(state, draftState => {
        draftState.activeYear = action instanceof fromActions.LoadHolidaysByYear ? action.payload.activeYear : '';
      });
    }
    case fromActions.HolidayActionTypes.LOAD_HOLIDAYS_SUCCESS: {
      return produce(state, draftState => {
        draftState.holidays = action instanceof fromActions.LoadHolidaysSuccess ? action.payload.holidays : [];
        draftState.loaded = true;
        draftState.loading = false;
        draftState.error = '';
      });
    }
    case fromActions.HolidayActionTypes.LOAD_HOLIDAYS_FAILURE: {
      return produce(state, draftState => {
        draftState.holidays = [];
        draftState.loaded = true;
        draftState.loading = false;
        draftState.error = action instanceof fromActions.LoadHolidaysFail ? action.payload.error : '';
      });
    }
    case fromActions.HolidayActionTypes.DELETE_HOLIDAY_SUCCESS: {
      return produce(state, draftState => {
        const holidayId = action instanceof fromActions.DeleteHolidaySuccess ? action.payload : '';
        draftState.holidays = draftState.holidays
          .filter(a => a.holidayId !== holidayId);
        draftState.loaded = true;
        draftState.loading = false;
        draftState.error = '';
      });
    }
    case fromActions.HolidayActionTypes.DELETE_HOLIDAY_FAIL: {
      return produce(state, draftState => {
        draftState.loaded = true;
        draftState.loading = false;
        draftState.error = action instanceof fromActions.DeleteHolidayFail ? action.payload.error : '';
      });
    }

    case fromActions.HolidayActionTypes.CREATE_HOLIDAY_SUCCESS: {
      return produce(state, draftState => {
        const payload = action instanceof fromActions.CreateHolidaySuccess ? action.payload : undefined;
        draftState.holidays.push(payload);
        draftState.loaded = true;
        draftState.loading = false;
        draftState.error = '';
      });
    }
    case fromActions.HolidayActionTypes.CREATE_HOLIDAY_FAIL: {
      return produce(state, draftState => {
        draftState.loaded = true;
        draftState.loading = false;
        draftState.error = action instanceof fromActions.CreateHolidayFail ? action.payload.error : '';
      });
    }
    case fromActions.HolidayActionTypes.UPDATE_HOLIDAY_SUCCESS: {
      return produce(state, draftState => {
        const payload = action instanceof fromActions.UpdateHolidaySuccess ? action.payload : undefined;
        draftState.holidays.forEach((obj, index )=> {
          if(obj.holidayId === payload.holidayId){
            draftState.holidays[index] = payload;
          }
        })
        draftState.loaded = true;
        draftState.loading = false;
        draftState.error = '';
      });
    }
    case fromActions.HolidayActionTypes.UPDATE_HOLIDAY_FAIL: {
      return produce(state, draftState => {
        draftState.loaded = true;
        draftState.loading = false;
        draftState.error = action instanceof fromActions.UpdateHolidayFail ? action.payload.error : '';
      });
    }
    default:
      return state;
  }
}
